module.exports = __webpack_public_path__ + "img/line-slim.97cffec4.svg";